export interface Title {
    title: string;
    href: string;
}

export const TITLES: Title[] = [
  { title: '/cryptMi-app', href:'#app' },
  { title: '/cryptMi-card', href:'#card' },
  { title: '/my-lifestyle', href:'#life' },
  { title: '/connect', href:'#connect' }

];
